import { Divider } from 'antd';
import clx from 'classnames';
import type React from 'react';
import styled from 'styled-components';

const StyledDivider = styled(Divider)`
  &.ant-divider {
    border-block-start-color: ${props => props.theme.colorPrimaryBorder};
    color: ${props => props.theme.colorPrimary};
    &.remove-top-margin {
      margin-top: 0;
    }
  }
`;

export interface DividerTitleElementProps {
  title?: React.ReactNode;
  /** Rimuove il margine superiore */
  removeTopMargin?: boolean;
  required?: boolean;
}

/**
 * Elemento divisore con titolo
 */
export function DividerTitleElement(props: DividerTitleElementProps) {
  if (!props.title) {
    return null;
  }

  return (
    <StyledDivider
      className={clx({ 'remove-top-margin': props.removeTopMargin })}
      orientation="left"
      orientationMargin="0"
    >
      {props.title} {props.required && <span style={{ color: 'red' }}>*</span>}
    </StyledDivider>
  );
}
